<div class="email-setting">
    <div class="vertical-forms-container">
        <form [formGroup]="emailSettingForm">
            <div class="email-setting-body  control-border">
                <div class="email-form">
                    <div class="email-form-left">
                        <div class="email-header-label">
                            <label class="label-1">{{'email.exchage_online_inbound_email_settings' |
                                stringLiterals}}</label>
                            <label class="label-2">{{'email.please_stop_fetchmail_first' | stringLiterals}}</label>
                            <label class="label-3">{{'email.when_oauth2_is_turned_on' | stringLiterals}}</label>
                        </div>

                        <div>
                            <button tam-button tamType="destructive" tamSize="normal"
                                [disabled]="isDisabledFetchMailButton" (click)="clickStopFetchMail()"
                                [tamLoading]="isLoadingStopEmail"
                                isLoadingStop="isLoadingStopEmail">{{'email.stop_fetchmail' |
                                stringLiterals}}</button>
                        </div>

                        <div>
                            <label class="label-2">{{'email.please_select_your_email_server' |
                                stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                            <kendo-dropdownlist formControlName="emailServer" class="email-type" [disabled]="true">
                            </kendo-dropdownlist>
                            <label class="label-3">{{'email.please_confirm_you_have' | stringLiterals}}</label>
                        </div>
                        <!--emailAddress-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': emailAddress.invalid}">
                            <label class="label-2 email-address">{{'email.email_addres_from' |
                                stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                            <input tid="email_address_from" class="tam-input email-input" formControlName="emailAddress"
                                (blur)="configChanged()" />

                            <div class="tam-form-help error-tip"
                                *ngIf="emailAddress.invalid && emailAddress.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>

                            <div class="tam-form-help error-tip"
                                *ngIf="emailAddress.invalid && emailAddress.errors['invalidEmail']">
                                {{'general.invalid_email_address_message' | stringLiterals}}
                            </div>
                        </div>
                        <!--emailAddress-->

                        <!--folderName-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': folderName.invalid}">

                            <label class="label-2">{{'email.email_account_folder' | stringLiterals}}&nbsp;<span
                                    class="required-field">*</span></label>
                            <input tid="email_account_folder" class="tam-input email-input" formControlName="folderName"
                                (keyup)="configChanged()" placeholder="{{'email.default_to_inbox' | stringLiterals}}" />

                            <div class="tam-form-help error-tip"
                                *ngIf="folderName.invalid && folderName.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>

                        </div>
                        <!--folderName-->

                        <!--periodSeconds-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': periodSeconds.invalid}">
                            <div class="label-container">
                                <label class="label-2">{{'email.mail_query_period_in_seconds' |
                                    stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                                <div class="icon" kendoTooltip position="top" tooltipClass="tooltip-adjust-right"
                                    [title]="'email.interval_in_seconds_for_fetching_emails' |stringLiterals ">
                                    <smart-icon name="info" class="notification">
                                    </smart-icon>
                                </div>
                            </div>

                            <kendo-numerictextbox class="numeric-input" [format]="'n0'" [step]="1" [min]="1"
                                formControlName="periodSeconds" (valueChange)="configChanged()"
                                placeholder="{{'email.default_to_10' | stringLiterals}}">
                            </kendo-numerictextbox>

                            <div class="tam-form-help error-tip"
                                *ngIf="periodSeconds.invalid && periodSeconds.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>

                        </div>
                        <!--periodSeconds-->


                        <!--receivedDatetime-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': receivedDatetime.invalid}">
                            <div class="label-container">
                                <label class="label-2">{{'email.first_receive_date_and_time' |
                                    stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                                <div class="icon" kendoTooltip position="top" tooltipClass="tooltip-adjust-right"
                                    [title]="'email.this_is_for_first_time_migrate_from_fetchmail' | stringLiterals">
                                    <smart-icon name="info" class="notification">
                                    </smart-icon>
                                </div>
                            </div>
                            <kendo-datetimepicker class="email-input " format="MM/dd/yyyy HH:mm:ss"
                                formControlName="receivedDatetime" (valueChange)="configChanged()">
                            </kendo-datetimepicker>

                            <div class="tam-form-help error-tip"
                                *ngIf="receivedDatetime.invalid && receivedDatetime.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>
                        <!--takeOverlapDays-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': takeOverlapDays.invalid}">
                            <div class="label-container">
                                <label class="label-2">{{'email.overlap_days' | stringLiterals}}&nbsp;<span
                                        class="required-field">*</span></label>
                                <div class="icon" kendoTooltip position="top" tooltipClass="tooltip-adjust-right"
                                    [title]="'email.overlap_days_to_be_used_in_case' | stringLiterals">
                                    <smart-icon name="info" class="notification">
                                    </smart-icon>
                                </div>
                            </div>

                            <kendo-numerictextbox class="numeric-input" [format]="'n0'" [step]="1" [min]="1"
                                formControlName="takeOverlapDays" (valueChange)="configChanged()"
                                placeholder="{{'email.e_g_1' | stringLiterals}}">
                            </kendo-numerictextbox>
                            <div class="tam-form-help error-tip"
                                *ngIf="takeOverlapDays.invalid && takeOverlapDays.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>
                        <!--takeOverlapDays-->

                        <label class="label-2">{{'email.keep_emails_on_server' | stringLiterals}}</label>
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="keepOnServer"
                            [data]="keepEmailServerData" class="email-type"
                            (valueChange)="clickKeepSeverChanged($event)">
                        </kendo-dropdownlist>
                        <div>
                            <button tam-button tamType="primary" tamSize="normal" class="submit-button"
                                [tamLoading]="isLoadingSubmit" [disabled]="isLoadingSubmit||!isChanged"
                                (click)="clickSubmitSetting()">{{'email.submit_all_settings'|stringLiterals}}</button>
                        </div>
                    </div>
                </div>

                <!--FetchApp buttons-->
                <div class="email-setting-action" *ngIf="isShowActionButton">

                    <button tam-button tamType="secondary" tamSize="normal" (click)="clickExportLog()"
                        class="action-button" [tamLoading]="isLoadingExport">{{'email.export_logs' |
                        stringLiterals}}</button>
                    <button *ngIf="isStartFetchApp" tam-button tamType="primary" tamSize="normal" class="action-button"
                        (click)="clickRestartFetchapp()" [tamLoading]="isLoadingRestart"
                        [disabled]="isLoadingRestart">{{'email.restart_fetchapp'|
                        stringLiterals}}</button>

                    <button *ngIf="isStartFetchApp" tam-button tamType="destructive" tamSize="normal"
                        class="action-button" (click)="clickStopFetchApp()" [tamLoading]="isLoadingStop"
                        [disabled]="isLoadingStop">{{'email.stop_fetchapp' |
                        stringLiterals}}</button>

                    <button *ngIf="!isStartFetchApp" tam-button tamType="primary" tamSize="normal" class="action-button"
                        (click)="clickStartFetchApp()" [tamLoading]="isLoadingStart"
                        isLoadingStop="isLoadingStart">{{'email.start_fetchapp' |
                        stringLiterals}}</button>
                </div>
            </div>
        </form>

        <form [formGroup]="mailSettingForm">
            <div class="email-setting-body  control-border">
                <div class="email-form">
                    <div class="email-form-left">
                        <label class="label-1">{{'email.smtp_outbound_email_settings' | stringLiterals}}</label>
                        <!--mailAddressFrom-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': mailAddressFrom.invalid}">
                            <label class="label-2 email-address">{{'email.mail_address_from' |
                                stringLiterals}}&nbsp;<span class="required-field">*</span></label>
                            <input tid="mail_address_from" class="tam-input email-input"
                                formControlName="mailAddressFrom" (blur)="clickMailChanged()" />

                            <div class="tam-form-help error-tip"
                                *ngIf="mailAddressFrom.invalid && mailAddressFrom.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                        <div class="tam-form-field">
                            <label class="label-2 button-text">{{'email.enable_smtp_authentication' |
                                stringLiterals}}</label>
                            <kendo-switch onLabel="On" offLabel="Off" [checked]="useSMTPAuth.value"
                                (valueChange)="changeAnthStatus($event)">
                            </kendo-switch>
                        </div>

                        <!--STMP Auth user-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': SMTPAuthUser.invalid}">
                            <label class="label-2">{{'email.smtp_auth_user' | stringLiterals}}&nbsp;</label>
                            <input tid="smtp_auth_user" class="tam-input email-input" formControlName="SMTPAuthUser"
                                (keyup)="clickMailChanged()" />

                            <div class="tam-form-help error-tip"
                                *ngIf="SMTPAuthUser.invalid && SMTPAuthUser.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                        <!--STMP Auth password-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': SMTPAuthPassword.invalid}">

                            <label class="label-2">{{'email.smtp_auth_password' | stringLiterals}}&nbsp;</label>
                            <input tid="smtp_auth_password" class="tam-input email-input"
                                formControlName="SMTPAuthPassword" (keyup)="clickMailChanged()"
                                [type]="useSMTPAuth.value ? 'text' : 'password'" />

                            <div class="tam-form-help error-tip"
                                *ngIf="SMTPAuthPassword.invalid && SMTPAuthPassword.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>

                        </div>

                        <!--SMTP serve encryption security-->
                        <div class="tam-form-field input-setting">
                            <label class="label-2">{{'email.smtp_server_encryption_security' | stringLiterals}}</label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                formControlName="SMTPEncryptionSecurity" [data]=" keepSmtpServeSercurity"
                                class="email-type" (valueChange)="clickMailChanged()">
                            </kendo-dropdownlist>
                        </div>

                        <!--Mail personal Name-->
                        <div class="tam-form-field input-setting" [ngClass]="{'has-error': mailPersonalName.invalid}">
                            <label class="label-2">{{'email.mail_personal_name' | stringLiterals}}&nbsp;<span
                                    class="required-field">*</span></label>
                            <input tid="mail_personal_name" class="tam-input email-input"
                                formControlName="mailPersonalName" (blur)="clickMailChanged()" />
                            <div class="tam-form-help error-tip"
                                *ngIf="mailPersonalName.invalid && mailPersonalName.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                        <!--Email SMTP server address-->
                        <div class="tam-form-field input-setting"
                            [ngClass]="{'has-error': emailSMTPServerAddress.invalid}">
                            <label class="label-2">{{'email.email_smtp_server_address' | stringLiterals}}&nbsp;<span
                                    class="required-field">*</span></label>
                            <input tid="email_smtp_server_address" class="tam-input email-input"
                                formControlName="emailSMTPServerAddress" (blur)="clickMailChanged()" />

                            <div class="tam-form-help error-tip"
                                *ngIf="emailSMTPServerAddress.invalid && emailSMTPServerAddress.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                        <!--Email SMTP port address-->
                        <div class="tam-form-field input-setting"
                            [ngClass]="{'has-error': emailSMTPServerPortAddress.invalid}">
                            <label class="label-2">{{'email.email_smtp_port_address' | stringLiterals}}&nbsp;<span
                                    class="required-field">*</span></label>
                            <input tid="email_smtp_port_address" class="tam-input email-input"
                                formControlName="emailSMTPServerPortAddress" (blur)="clickMailChanged()" />

                            <div class="tam-form-help error-tip"
                                *ngIf="emailSMTPServerPortAddress.invalid && emailSMTPServerPortAddress.errors['required']">
                                {{'general.required_error_message' | stringLiterals}}
                            </div>
                        </div>

                        <!--Relay To Address-->
                        <div class="tam-form-field input-setting">
                            <label class="label-2">{{'email.reply_to_address' | stringLiterals}}</label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                formControlName="relayToAddress" [data]="keepReplyAdress" class="email-input"
                                (valueChange)="clickMailChanged()">
                            </kendo-dropdownlist>
                        </div>

                        <!--From Display Name-->
                        <div class="tam-form-field input-setting">
                            <label class="label-2">{{'email.from_display_name' | stringLiterals}}</label>
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}"
                                formControlName="fromDisplayName" [data]="keepDisplayName" class="email-input"
                                (valueChange)="clickMailChanged()">
                            </kendo-dropdownlist>
                        </div>

                        <div>
                            <button tam-button tamType="primary" tamSize="normal" class="submit-button"
                                [tamLoading]="isLoadingSubmit2" [disabled]="isLoadingSubmit2||!isChanged2"
                                (click)="clickSubmitMailSetting()">{{'email.submit_all_smtp_settings'|stringLiterals}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>